import { Card } from "../components/Card";
import followusicon from "../assets/images/find-us-on-facebook-logo.png";
import { Link } from "react-router-dom";

export default function Home({ containerRef }) {

  return (
    <>
      <SiblingBanner />
      <Card id="welcome" className="welcome" bgc="fill" title="Welcome to the Conner Family Reunion - 2025!">
        <p>
          <a className="fb onright" href="http://www.facebook.com/groups/ConnerReunion" target="connertab"><img className="fb" src={followusicon} alt="Follow us on Facebook" /></a>
          This year’s Conner Reunion is to be held <strong>Saturday, June 21st and Sunday June 22nd, 2025</strong>, in
          West Plains, MO.  We have secured a facility at Pomona Christian Church in Pomona, Missouri.  Please make every
          effort to join us!
        </p>
        <p>
          The web site has a new look!  It has been completely rewritten with enhanced features in the address
          section. You can take a tour of the new features, review a Quick Start list of things to do, filter
          family members by the Conner sibling, or just browse through all the family member inforamation.
        </p>
        <p>
          <Link to="/addresses"><button className="btn btn-primary">Check out the updated address list!</button></Link>
        </p>
      </Card>
      <Card id="welcome1.5" className="welcome" bgc="fill" title="Update - 06/02/2025">
        <div>
          Take a look at the <a href="/media/pdfs/Conner_Family_Reunion_Letter_2025.pdf" target="connertab">most recent reunion letter</a> to get the latest details about the reunion!
        </div>
      </Card>
      <Card id="welcome2" className="welcome" bgc="fill" title="">
        <div>
          We have secured a block of rooms for the reunion at the same hotel as last reunion - <strong>The Hampton Inn West</strong>.
          Take a look at our <Link to="/lodging">lodging details</Link> for more information on the rooms available.
        </div>
      </Card>
      <Card id="welcome3" className="welcome" bgc="fill" title="">
        {/* <div>
          Everything for this year's reunion is still being finalized, so check back to see the latest updates
          to our schedule.
        </div> */}
        <p>
          Take a look at the <Link to="/schedule">schedule for the 2025 reunion</Link> so you don't miss any event!  Note that
          this schedule <i>may</i> change slightly, but this is pretty close to what we'll do.  Check back here for any
          updates.
        </p>
        <div>
          Please note the time for group pictures on the <Link to="/schedule">schedule for the 2025 reunion</Link> and 
          make every effort to have your family all present to make this process go quickly and smoothly.
        </div>
      </Card>
    </>
  );
}

function SiblingBanner() {
  return (
    <article className="siblinggallery level">
      <h2>Children of Eugene and Nellie Conner</h2>
      <div className="siblinggroup">
        <Sibling id="A1" row="1" col="1">Mary</Sibling>
        <Sibling id="B1" row="1" col="2">Bill</Sibling>
        <Sibling id="C1" row="1" col="3">Polly</Sibling>
        <Sibling id="D1" row="1" col="4">Horace</Sibling>
        <Sibling id="E1" row="1" col="5">Stanley</Sibling>
        <Sibling id="F1" row="1" col="6">Wilma</Sibling>
        <Sibling id="G1" row="1" col="7">Richard</Sibling>
        <Sibling id="A2" row="2" col="1">Dorthea</Sibling>
        <Sibling id="B2" row="2" col="2">Joanna</Sibling>
        <Sibling id="C2" row="2" col="3">Marjorie</Sibling>
        <Sibling id="D2" row="2" col="4">Ruth</Sibling>
        <Sibling id="E2" row="2" col="5">Glen</Sibling>
        <Sibling id="F2" row="2" col="6">Marvin</Sibling>
        <Sibling id="G2" row="2" col="7">Gene</Sibling>
      </div>
    </article>
  )
}

function Sibling({id,row,col, children, ...props}) {
  const classNamesCombined = `r${row} c${col}`;
  return (
    <div id={id} className={`${classNamesCombined}`}>
      <div>{children}</div>
    </div>
  )
}

